<template>
    <div class="eda-olist">

        <h1 class="eda-olist__heading">
            {{ $t('orderList.heading') }}
        </h1>

        <div class="eda-olist__content">

            <div class="eda-olist__filters">
                <div class="eda-olist__filter">
                    <eda-list-search

                            :label="$t('orderList.filters.search')"
                            v-model="internalSearch"
                            @input="searchTyping"
                            :dark-theme="true">
                    </eda-list-search>
                </div>

                <div class="eda-olist__filter-box">
                    <checkbox-list
                            :label="$t('flags.heading')"
                            @input="loadData"
                            v-model="flags"
                            :options="flagOptions">
                    </checkbox-list>
                </div>

                <div class="eda-olist__filter-box">
                    <checkbox-list
                            label="Installatørstatus"
                            @input="loadData"
                            v-model="installerStatus"
                            :options="installerStatusOptions">
                    </checkbox-list>
                </div>

                <div class="eda-olist__filter-box">
                    <checkbox-list
                            label="Status"
                            @input="loadData"
                            v-model="status"
                            :options="statusOptions">
                    </checkbox-list>
                </div>

            </div>


            <div class="eda-olist__list">

                <div class="eda-olist__options">

                    <div class="eda-olist__stats">
                        <eda-link to="/reports">
                            <eda-icon class="eda-olist__reports-icon" icon="stats"></eda-icon>
                        </eda-link>
                    </div>
                    <div class="eda-olist__pagination">


                        <div class="eda-olist__pagination-filter">
                            <eda-list-filter
                                    v-model="sortObject"
                                    @input="loadData"
                                    :legend="$t('orderList.view.sort.heading')"
                                    :options="sortOptions">
                            </eda-list-filter>
                        </div>

                        <div class="eda-olist__pagination-filter">
                            <eda-list-filter @input="loadData"
                                             :legend="$t('orderList.view.page.heading')"
                                             v-model="pageObject"
                                             :options="pageOptions">
                            </eda-list-filter>
                        </div>
                    </div>

                </div>


                <eda-ellipsis-loader v-if="!loaded"></eda-ellipsis-loader>

                <template v-for="item in items">
                    <div class="eda-olist__item">
                        <eda-order-list-item v-bind="item"
                        ></eda-order-list-item>
                    </div>
                </template>
                <template v-if="loaded && !items.length">
                    <div class="eda-olist__no-items">
                        {{ $t('orderList.empty' )}}
                    </div>

                </template>


                <div class="eda-olist__pagination eda-olist__pagination--under"
                     v-if="loaded && pagination.total_pages > 1">

                    <div class="eda-olist__pagination-filter">
                        <eda-list-filter @input="loadData"
                                         :legend="$t('orderList.view.sort.heading')"
                                         v-model="sortObject"
                                         :options="sortOptions">
                        </eda-list-filter>
                    </div>

                    <div class="eda-olist__pagination-filter">
                        <eda-list-filter
                                v-model="pageObject"
                                @input="loadData"
                                :legend="$t('orderList.view.page.heading')"
                                :options="pageOptions">
                        </eda-list-filter>
                    </div>
                </div>

            </div>

        </div>
    </div>

</template>

<script>

  import EdaListFilter from "../components/vListFilter"
  import EdaList from "../components/vList"
  import EdaListSearch from "../components/vInput"
  import EdaOrderListItem from "../components/vOrderListItem"
  import CheckboxList from "../components/vCheckboxList"
  import apiMixin from "../mixins/apiMixin";
  import EdaIcon from "../components/vIcon"
  import EdaLink from "../components/vLink"
  import axios from "axios"
  import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions';
  import EdaEllipsisLoader from "../components/vEllipsisLoader"
  import STATUS from "../config/status/order.js"
  import FLAGS from "../config/flags/config.js"

  import INSTALLER_STATUS from "../config/status/adminInstaller.js"
  import _ from 'lodash'
  import { mapGetters, mapActions } from 'vuex'
  import IconCheckRound from "../components/icons/check";

  export default {
    name: "EdaOrderList",
    mixins: [
      apiMixin.apiMixin,
    ],
    components: {
      IconCheckRound,
      EdaList,
      EdaEllipsisLoader,
      EdaOrderListItem,
      EdaListFilter,
      EdaIcon,
      EdaLink,
      EdaListSearch,
      CheckboxList
    },
    props: {
      page: { type: Number, default: 1 },
      sort: { type: String, default: "date.desc" },
      search: { type: String, default: "*" },
      statusOptions: {
        type: Array, default:
          function () {
            return STATUS
          }
      },
      flagOptions: {
        type: Array, default:
          function () {
            return FLAGS
          }
      },
      installerStatusOptions: {
        type: Array, default:
          function () {
            return INSTALLER_STATUS
          }
      },
      sortOptions: {
        type: Array, default: function () {
          return [
            { 'label': this.$t('orderList.view.sort.dateDesc'), 'id': 'date.desc' },
            { 'label': this.$t('orderList.view.sort.dateAsc'), 'id': 'date.asc' }
          ]
        }
      }
    },
    data: function () {
      return {
        items: [],
        internalSort: this.sort,
        internalPage: this.page,
        internalSearch: this.search === "*" ? "" : this.search.replace("-", " "),
        loaded: false,
        call: null, // used for cancel tokens
        //     status: [],
        pagination:
          {
            count: null,
            current_page: null,
            per_page: null,
            total: null,
            total_pages: null
          }
        ,
      }
    }
    ,
    mounted() {

      if (!this.status || !this.status.length) {
        this.status = this.getFilterDefaults(STATUS);
      }

      if (!this.filter || !this.filter.length) {
        this.filter = this.getFilterDefaults(FLAGS);
      }

      this.loadData();
    },


    computed: {
      ...mapGetters([
        'getUser',
        'getHttp'
      ]),
      pageOptions() {
        let options = [];
        if (this.pagination.total_pages) {
          for (var i = 1; i <= this.pagination.total_pages; i++) {
            options.push({ "label": i, "id": i });
          }
        }
        return options;
      },

      flags: {
        get() {
          return this.getUser.filters.flags;
        },
        set(value) {
          this.rememberOrderFilters({ flags: value });
        }
      },

      status: {
        get() {
          return this.getUser.filters.status;
        },
        set(value) {
          this.rememberOrderFilters({ status: value });
        }
      },

      installerStatus: {
        get() {
          return this.getUser.filters.installerStatus;
        },
        set(value) {
          this.rememberOrderFilters({ installerStatus: value });
        }
      },


      pageObject: {
        get() {
          var that = this;
          return this.pageOptions.filter(obj => {
            return obj.id == that.internalPage
          })[0];
        }
        ,
        set(value) {
          this.internalPage = value.id;
        }
      }
      ,
      sortObject: {
        get() {
          var that = this;
          return this.sortOptions.filter(obj => {
            return obj.id == that.internalSort
          })[0];
        }
        ,
        set(value) {
          this.internalSort = value.id;
        }
      }
      ,
      sortQuery() {
        let map = {
          "date.desc": "dateCreated desc",
          "date.asc": "dateCreated asc",
        }
        return map[this.internalSort];
      }
    }
    ,


    methods: {
      ...mapActions([
        'setUser',
        'rememberOrderFilters',
      ]),

      transformItem(item) {
        // no trafo needed yet
        return item;
      },

      getFilterDefaults(conf) {
        return conf.filter(opt => opt.filterDefault).map(opt => opt.value);
      },

      setRoute() {
        this.$router.push({
          name: "orders-filtered",
          params: {
            search: this.internalSearch === "" ? "*" : this.internalSearch.replace(/\s/g, "-"),
            sort: this.internalSort,
            page: this.internalPage
          }
        });
      },

      pushResponse(response) {

        console.log("pushing response");

        this.items = [];
        var data = response.data.data;
        for (var index in data) {
          this.items.push(this.transformItem(data[index]))
        }

        this.pagination = response.data.meta.pagination;
        this.loaded = true;

      },

      searchTyping() {
        this.setRoute();
        this.debounceLoadData()
      }
      ,


      debounceLoadData: _.debounce(function () {
        this.loadData();
      }, 400),

      loadData() {
        var that = this;
        if (that.call) {
          that.call.cancel();
        }

        that.call = axios.CancelToken.source();
        that.items = [];
        that.loaded = false;

        /* axios with cache adapter */
        const http = this.getHttp;

        let conf = this.apiHeaders;
        conf.headers['Cache-Control'] = 'no-cache';

        conf.params = {
          'page': that.internalPage,
          'search': that.internalSearch,
          'order': that.sortQuery,
          'status': that.status,
          'installerStatus': that.installerStatus,
        }

        conf.cancelToken = that.call.token;

        for (let key in that.flags) {
          conf.params[that.flags[key]] = 1;
        }

        this.setRoute();


        // todo: generalize two following sections:
        // use cache if available
        conf.forceUpdate = false;
        http.get(process.env.VUE_APP_API_URL + "/orders", conf).then(function (response) {
          console.log(response);
          that.pushResponse(response)
        });

        // do the actual request
        conf.forceUpdate = true;
        http.get( process.env.VUE_APP_API_URL + "/orders", conf).then(function (response) {
          that.pushResponse(response)
        });


      }
    }
    ,

  }
</script>

<style>
    .eda-olist {
        text-align: center;
    }

    .eda-olist__item {
        padding: 0.25em 0;
    }

    .eda-olist__content {
        justify-content: center;
        display: flex;
    }

    .eda-olist__options {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .eda-olist__stats {
        width: 4em;
    }

    .eda-olist__reports-icon {
        width: 1.5em;
    }

    .eda-olist__filters {
        display: flex;
        padding: 3em 1em 1em 0;
        flex-direction: column;
        width: 17em;
        flex: none;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .eda-olist__pagination {
        display: flex;
        padding-bottom: 1em;
        font-size: .8em;
        justify-content: flex-end;
    }

    .eda-olist__list {
        width: calc(100% - 22em);
    }

    .mq-mobile .eda-olist__filters {
        flex-direction: column;
    }

    .eda-olist__filter {
        width: 100%;
        font-size: .9em;
    }

    .eda-olist__pagination-filter {

    }

    .mq-tablet .eda-olist__filter,
    .mq-mobile .eda-olist__filter {
        font-size: 0.8em;
        padding: .2em
    }

    .eda-olist__no-items {
        color: white;
    }

    .eda-olist__filter-box {
        font-size: .9em;
        width: 100%;
        border-radius: 1em;
        background-color: #0d1a0f;
        padding: 1.5em 2em;
        margin: .25em 0;
        color: white;
    }

    .eda-olist__heading {
        padding: 1em 0;
        font-weight: 400;
        color: white;
    }

    .mq-tablet .eda-olist__heading,
    .mq-mobile .eda-olist__heading {
        font-size: 1.5em;

    }

</style>